import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-recorridos",
  templateUrl: "./recorridos.component.html",
  styleUrls: ["./recorridos.component.scss"]
})
export class RecorridosComponent implements OnInit {
  constructor() {}

  optionsComuna: Array<any> = [];
  optionsRuta: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsChofer: Array<any> = [];
  optionsPatente: Array<any> = [];

  ngOnInit() {
    this.optionsPatente = [
      { value: "1", label: "Patente 1" },
      { value: "2", label: "Patente 2" },
      { value: "3", label: "Patente 3" }
    ];
    this.optionsChofer = [
      { value: "1", label: "Chofer 1" },
      { value: "2", label: "Chofer 2" },
      { value: "3", label: "Chofer 3" }
    ];
    this.optionsComuna = [
      { value: "1", label: "Comuna 1" },
      { value: "2", label: "Comuna 2" },
      { value: "3", label: "Comuna 3" }
    ];
    this.optionsRuta = [
      { value: "1", label: "Ruta 1" },
      { value: "2", label: "Ruta 2" },
      { value: "3", label: "Ruta 3" }
    ];
    this.optionsVendedor = [
      { value: "1", label: "Vendedor 1" },
      { value: "2", label: "Vendedor 2" },
      { value: "3", label: "Vendedor 3" }
    ];
  }
}
